import { AxiosResponse } from 'axios'

import axiosAuth from './axiosAuth'

export const getMessageTemplates = (): Promise<
    AxiosResponse<IMessageTemplate[]>
> => axiosAuth.get(`/message-templates`)

export const getMessageTemplate = (
    key: string
): Promise<AxiosResponse<IMessageTemplate>> =>
    axiosAuth.get(`/message-templates/${key}`)

export const updateMessageTemplate = (
    key: string,
    data: IUpdateMessageTemplate
) => axiosAuth.put(`/message-templates/${key}`, data)

export interface IUpdateMessageTemplate {
    kind: string
    messages: Record<string, string>
}

export interface IMessageTemplate {
    id: string
    key: string
    kind: string
    messages: Record<string, string>
}
